import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import { type ReactNode } from 'react';

import theme, { mantineCssVariablesResolver } from '../lib/theme';

// Configure the color scheme manager to use localStorage with our key
const colorSchemeManager = localStorageColorSchemeManager({
  key: 'mantine-color-scheme',
});

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <>
      <MantineProvider
        theme={theme}
        defaultColorScheme="light"
        cssVariablesResolver={mantineCssVariablesResolver}
        colorSchemeManager={colorSchemeManager}
      >
        {children}
      </MantineProvider>
    </>
  );
}
